/**
 * Maps our internal team abbreviations (abbrv) to CEE TeamCode values.
 * @see configs/cee-id.ts for the canonical CEE team list.
 *
 * Many abbrvs match TeamCode directly; this file only lists exceptions
 * (renamed clubs, women's teams, and legacy abbreviations).
 */
const ABBRV_TO_TEAM_CODE: Record<string, string> = {
	// Men's teams where abbrv differs from CEE TeamCode
	DIF: 'DJU',
	DEIF: 'DIF',
	HIF: 'HEL',
	IKB: 'BRA',
	IFBP: 'BP',
	IKS: 'SIR',
	LAN: 'LBOIS',
	LJUN: 'LSK',
	OIF: 'ÖIF',
	OFK: 'ÖFK',
	OIS: 'ÖIS',
	OSK: 'ÖRE',
	SANDIF: 'SIF',
	SKAIK: 'SAIK',
	SUN: 'GIF',
	UME: 'UFC',
	VARN: 'VÄR',
	JON: 'JÖN',
	AFC: 'ATH',

	// Women's teams (DAM*) map to the parent club's CEE TeamCode
	DAMAIK: 'AIK',
	DAMBKH: 'BKH',
	DAMBP: 'BP',
	DAMDIF: 'DJU',
	DAMHAM: 'HAM',
	DAMIFE: 'IFE',
	DAMMFF: 'MFF',
	DAMNOR: 'NOR',
	DAMORE: 'ÖRE',
	DAMSUN: 'GIF',
	DAMSUND: 'GIF',
	DAMTFF: 'TFF',
};

const CEE_TEAM_CODES = new Set([
	'ATH',
	'AIK',
	'AIF',
	'BKH',
	'DAL',
	'DIF',
	'DJU',
	'FFF',
	'GAIS',
	'GEF',
	'GIF',
	'HBK',
	'HAM',
	'HEL',
	'BP',
	'IFE',
	'GBG',
	'NOR',
	'VÄR',
	'BRA',
	'FREJ',
	'IKO',
	'SIR',
	'JÖN',
	'KFF',
	'LBOIS',
	'LSK',
	'MFF',
	'MAIF',
	'NFC',
	'NIF',
	'_SVE',
	'SIF',
	'_SEF',
	'SEFK',
	'SAIK',
	'_SFL',
	'SFC',
	'TFF',
	'UFC',
	'UBK',
	'VAR',
	'VIF',
	'VSK',
	'ÅFF',
	'ÖRE',
	'ÖIS',
	'ÖIF',
	'ÖFK',
]);

export function abbrvToTeamCode(abbrv: string): string | undefined {
	const normalized = abbrv.toUpperCase();

	if (ABBRV_TO_TEAM_CODE[normalized]) {
		return ABBRV_TO_TEAM_CODE[normalized];
	}

	if (CEE_TEAM_CODES.has(normalized)) {
		return normalized;
	}

	return undefined;
}
